export default __webpack_public_path__ + "static/media/waves.960eecd5.svg";